module.exports = __webpack_public_path__ + "static/media/group_176.fce8468b.svg";